import { MouseEvent, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { DeviceRegistrationItem } from "../../models/device";
import { ReactComponent as CloseIcon } from "../../assets/Close.svg";
import "./AddLiftsConfirm.css";

type AddLiftsConfirmProps = {
  isOpen: boolean;
  devices: DeviceRegistrationItem[];
  onCancel: () => void;
  onConfirm: () => void;
};

export const AddLiftsConfirm = ({
  isOpen,
  devices,
  onCancel,
  onConfirm,
}: AddLiftsConfirmProps) => {
  const { t } = useTranslation();
  const modalRef = useRef<HTMLDialogElement | null>(null);

  useEffect(() => {
    if (isOpen) {
      modalRef.current?.showModal();
    } else {
      modalRef.current?.close();
    }
  }, [isOpen]);

  const handleConfirm = async (e: MouseEvent) => {
    e.preventDefault();
    onConfirm();
  };

  return (
    <dialog ref={modalRef} onCancel={onCancel}>
      <div className="add-lifts-confirm-dialog-content">
        <div className="add-lifts-confirm-dialog-close-icon-div">
          <CloseIcon className="dialog-close-icon" onClick={onCancel} />
        </div>
        <h1 className="add-lifts-confirm-dialog-header">
          {t("confirm_add_device_title", { ns: "lift" })}
        </h1>
        <p>{t("confirm_add_device_info", { ns: "lift" })}</p>
        <div className="add-lifts-confirm-serial-list">
          {devices.map((device, i) => (
            <div key={i}>
              <b>{device.serialNumber}</b>{" "}
              {device.nickname ? " - " + device.nickname : ""}
            </div>
          ))}
        </div>
        <div className="modal-btn-div">
          <button
            type="button"
            className="button modal-close-btn"
            onClick={onCancel}
          >
            {t("edit_serial_number_btn", { ns: "lift" })}
          </button>
          <button
            className="button modal-confirm-dialog-btn"
            onClick={(e) => {
              handleConfirm(e);
            }}
          >
            {t("confirm", { ns: "translation" })}
          </button>
        </div>
      </div>
    </dialog>
  );
};
